import {useCallback} from 'react';

import {createSelectableContext} from '@web-catalog/utils/selectableContext';

const {Context, useContextValueSelector, useCreateContextValueStore} =
  createSelectableContext<Array<boolean>>([]);

export type VisibilityContextOptions = {
  childrenCount: number;
  initialVisibleElements: number;
  observerMarginPx: number;
};

export const useIsVisibleInScroller = (itemPosition: number) => {
  const selector = useCallback(
    (visibilityArray: Array<boolean>) => visibilityArray[itemPosition] ?? false,
    [itemPosition],
  );
  return useContextValueSelector(selector);
};

export const ScrollerContextProvider = Context.Provider;

export const useCreateScrollerVisibilityContextStore = (
  config: VisibilityContextOptions | undefined,
) => {
  const scrollerContextInitialState = Array.from(
    Array(config?.childrenCount ?? 0).keys(),
  ).map((index) => index <= (config?.initialVisibleElements ?? 0));
  return useCreateContextValueStore(scrollerContextInitialState);
};
